// src/components/ProtectedRoute.jsx
import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) return null; // or a spinner
  if (!isAuthenticated) return <Navigate to="/" replace />; // or wherever you want them to land

  return children;
};

export default ProtectedRoute;
